
export const getWatermarkForRetailer = (watermarks, retailerId, dateAccessor) => {
        const retailerData = watermarks.filter(x => x.retailerId.toString() === retailerId.toString())[0]
        return retailerData && retailerData[dateAccessor]
}



